import {Mapper} from '@s-ui/domain'

/**
 * @implements Mapper
 */
export default class TrackingTechnicalDetailsMapper extends Mapper {
  /**
   * @constructor
   * @param {Object} param
   * @param {Object} param.config
   * @param {Object} param.fromPageTrackingJsonToTrackingDataValueObjectMapper
   */
  constructor({config, fromPageTrackingJsonToTrackingDataValueObjectMapper}) {
    super()

    this._config = config
    this._fromPageTrackingJsonToTrackingDataValueObjectMapper = fromPageTrackingJsonToTrackingDataValueObjectMapper
  }

  /**
   * @param {Object} param
   * @param {String} param.page
   * @param {String} param.culture
   * @param {Object} param.data
   * @param {String} param.data.make
   * @param {String} param.data.model
   * @param {String} param.data.bodyType
   * @param {String} param.data.version
   * @param {Array} param.data.vehicles
   * @param {String} param.data.title
   * @param {Number} param.data.pageNumber
   * @param {Object} param.data.filters
   * @param {Number} param.data.searchResultsCount
   */

  _getComparationVehicleData(vehicle) {
    if (!vehicle) return
    const {make, model, bodyType, year, version} = vehicle
    return `${make}:${model}:${bodyType}:${year}:${version}`
  }

  map({page, culture, data}) {
    const {make, model, bodyType, version, vehicles, title, pageNumber, filters, lastFilter, searchResultsCount} = data

    const trackingData = {}

    switch (page) {
      case 'TECHNICAL_DETAILS_COMPARATOR_RESULTS':
        if (vehicles && Array.isArray(vehicles) && vehicles.length) {
          if (vehicles[0]) {
            trackingData.compare_information1 = this._getComparationVehicleData(vehicles[0])
          }
          if (vehicles[1]) {
            trackingData.compare_information2 = this._getComparationVehicleData(vehicles[1])
          }
        }
        break
      case 'TECHNICAL_DETAILS_MAKE':
        if (make) trackingData.page_category_level3 = make
        break
      case 'TECHNICAL_DETAILS_MODEL':
        if (make && model) {
          trackingData.page_category_level3 = `${make} ${model}`
        }
        break
      case 'TECHNICAL_DETAILS_BODY_TYPE':
        if (make && model && bodyType) {
          trackingData.page_category_level3 = `${make} ${model} ${bodyType}`
        }
        break
      case 'TECHNICAL_DETAILS_VERSION':
        if (make && model && version) {
          trackingData.page_category_level3 = `${make} ${model} ${version}`
        }
        break
      case 'TECHNICAL_DETAILS_SEARCH_ENGINE':
        if (pageNumber) trackingData.list_page_num = pageNumber
        if (filters && Object.keys(filters).length) {
          trackingData.filters = filters
        }
        if (searchResultsCount) {
          trackingData.search_result_number = searchResultsCount
        }
        break
      case 'TECHNICAL_DETAILS_VEHICLE':
        if (make && model) {
          trackingData.page_category_level3 = make.toUpperCase()
          trackingData.page_category_level4 = model.toUpperCase()
        }
        break
      case 'TECHNICAL_DETAILS_VEHICLE_WITHOUT_VERSION':
        if (title) trackingData.page_category_level3 = title
        break
      case 'TECHNICAL_DETAILS_RESUME':
        if (title) trackingData.page_category_level3 = title
        break
      case 'TECHNICAL_DETAILS_SEARCH':
      case 'TECHNICAL_DETAILS_SEARCH_RESULTS':
        if (pageNumber) trackingData.list_page_num = pageNumber
        if (searchResultsCount) {
          trackingData.search_result_number = searchResultsCount
        }
        if (filters && Object.keys(filters).length) {
          trackingData.filters = filters
        }
        if (lastFilter) {
          trackingData.last_filter = lastFilter
        }
        break
      default:
        throw new Error(`No tracking data defined for page ${page}`)
    }

    return this._fromPageTrackingJsonToTrackingDataValueObjectMapper
      .setParams({
        page,
        culture
      })
      .map(trackingData)
  }
}
